import {useState} from "react";
import "./CardFavoris.scss";
import "../../styles/colors.scss";
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHeartCrack} from "@fortawesome/free-solid-svg-icons";
import RedirectToProductDetails from "../RedirectToProductsDetails/RedirectToProductDetails";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

function CardFavoris({coverArticle, prixArticle, nomArticle, idProduct, setFavoris}) {
    const [imageClique, setImageClique] = useState(false);
    const navigate = useNavigate();
    const jwtToken = Cookies.get("auth_token");

    const handleDeleteFavorite = async (e) => {
        e.stopPropagation(); // Évite de déclencher le clic sur l'image
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}favoris/delete`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                    body: JSON.stringify({
                        idProduct: idProduct,
                    }),
                }
            );
            if (response.ok) {
                const favoris = await response.json();
                setFavoris(favoris);
                Swal.fire({
                    text: "Produit supprimé des favoris avec succès !",
                    toast: true,
                    showConfirmButton: false,
                    background: "#22242a",
                    timer: 2000,
                    position: "top-start",
                    padding: "0.5em",
                    color: "#ffffff",
                });
            } else {
                console.error("Erreur lors de la suppression des données.");
            }
        } catch (error) {
            console.error("Erreur de connexion au serveur:", error);
        }
    };

    return (
        <div className="favoris-card">
            <button className="favoris-remove-btn" onClick={handleDeleteFavorite} title="Retirer des favoris">
                <FontAwesomeIcon icon={faHeartCrack} />
            </button>
            <div className="favoris-img-container" onClick={() => setImageClique(true)}>
                <img src={coverArticle} alt={nomArticle || 'image produit favoris'} />
                {imageClique && (
                    <RedirectToProductDetails
                        idProduct={idProduct}
                        imageClique={imageClique}
                    />
                )}
            </div>
            <div className="favoris-content">
                <h4 className="favoris-title" title={nomArticle}>{nomArticle}</h4>
                <p className="favoris-price">{prixArticle.toFixed(2)} €</p>
            </div>
        </div>
    );
}

CardFavoris.propTypes = {
    coverArticle: PropTypes.string.isRequired,
    prixArticle: PropTypes.number.isRequired,
    nomArticle: PropTypes.string.isRequired,
    idProduct: PropTypes.string.isRequired,
    setFavoris: PropTypes.func.isRequired
};

export default CardFavoris;
